import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";

function Login(args) {
    const [data, setData] = useState("success")
    const navigate = useNavigate()
    const requestManager = args.requestManager

    function validate() {
        const username = document.getElementsByName("username")[0].value
        const password = document.getElementsByName("password")[0].value
        const authDiv = document.getElementById("authDiv")

        authDiv.style.display = ""

        requestManager.request("login", "POST", { username: username, password: password }).then(res => res.json()).then((response) => {
            console.log(response)
            if (typeof response.status !== "undefined") {
                if (response.status == "success") {
                    document.cookie = "authKey=" + response.key + ";max-age=10000;"
                    requestManager.authKey = response.key
                    navigate("/")
                } else {
                    setData("failed")
                    authDiv.style.display = "none"
                }
            }
        })
    }

    return (
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-9">
                    <form class="form" method="post">
                        <div class="form-floating mt-5">
                            <input type="text" class="form-text form-control" id="floatingInput" autocomplete="off" name="username" placeholder="Username"></input>
                            <label class="form-label" for="floatingInput">Username</label>
                        </div>
                        <div class="form-floating mt-3">
                            <input type="password" class="form-text form-control" id="floatingInput" autocomplete="off" name="password" placeholder="Password"></input>
                            <label class="form-label" for="floatingInput">Password</label>
                        </div>
                    </form>
                    <div class="d-flex justify-content-center">
                        <input type="submit" onClick={validate} class="btn btn-success mt-4 d-flex justify-content-center"></input>
                    </div>
                    <div id="authDiv" class="justify-content-center" style={{ display: "none" }}>
                        <h1 class="mt-5 d-flex justify-content-center loading">Authenticating</h1>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Login